export function safeParse(maybeJsonString: string) {
  let result;
  try {
    result = JSON.parse(maybeJsonString);
  } catch (e) {
    console.warn( "safeParse failed with error: ", e);
    result = {};
  }
  return result;
}

export function safeParseBool(maybeJsonString: string) {
  let result;
  try {
    result = JSON.parse(maybeJsonString);
  } catch (e) {
    console.warn( "safeParseBool failed with error: ", e);
  }
  return result;
}